import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Menu from './pages/Menu';
import ItemDetails from './pages/ItemDetails';
import AdminSetup from './pages/admin/AdminSetup';
import RestaurantMenu from './pages/RestaurantMenu';
import NotFound from './pages/NotFound';
import './styles/global.css';
import AdminItemDetails from "./pages/admin/AdminItemDetails";
import CategoryItemsPage from "./pages/CategoryItemsPage";
import ARViewPage from "./pages/ARViewPage";


import AdminLogin from "./pages/admin/AdminLogin";
import AdminSignup from "./pages/admin/AdminSignup";
import ProtectedRoute from "./components/ProtectedRoute";
import CreateRestaurant from "./pages/admin/CreateRestaurant.js";
import ARCamera from "./pages/ARCamera.js";


import { useState } from "react";
import Sidebar from "./components/Sidebar";



function RootRoute() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const restaurantId = searchParams.get('id');

  return restaurantId ? <RestaurantMenu /> : <RestaurantMenu />;
}

function App() {

  const [isSidebarOpen, setSidebarOpen] =
    useState(false);

  return (
    <Router>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >

        {/* Navbar */}
        <Navbar
          onMenuClick={() =>
            setSidebarOpen(true)
          }
        />

        {/* Sidebar */}
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() =>
            setSidebarOpen(false)
          }
        />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/item/:id" element={<ItemDetails />} />
            <Route path="/restaurant" element={<RestaurantMenu />} />
            <Route path="*" element={<NotFound />} />

            <Route
              path="/admin/item/:restaurantId/:itemId"
              element={<AdminItemDetails />}
            />

            <Route
              path="/category/:category"
              element={<CategoryItemsPage />}
            />

            <Route
              path="/ar-view/:id"
              element={<ARViewPage />}
            />

            <Route
              path="/login"
              element={<AdminLogin />}
            />

            <Route
              path="/signup"
              element={<AdminSignup />}
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminSetup />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/create-restaurant"
              element={<CreateRestaurant />}
            />

            <Route
              path="/ar-camera"
              element={<ARCamera />}
            />

          </Routes>
        </main>

        <Footer />

      </div>
    </Router>
  );
}
export default App;
